import { Action, ActionType } from "@redux/actionTypes/filingCostActionType";
import { Reducer } from "react";

export interface IFilingCostState {
  filingCostDetailsByPID: IFilingCostDetailsByPID[];
}

export interface IFilingCostDetailsByPID {
  projectId: number;
  projectName?: string;
  filingCostDetails: IFilingCostDetails[];
  countries?: countryList[];
}
export interface countryList {
  countryID: number;
  name: string;
}
export interface IFilingCostDetails {
  detailId?: number;
  countryId?: number;
  country: string;
  dosageForm: string;
  packStyle: string;
  strength: string;
  strengthUnit: string;
  packTradeDress: string;
  filingCostId?: number;
  submissionType: string;
  estimatedFilingDate: string;
  estimatedApprovalDate: string;
  estimatedFilingFees: number;
}

const initialState = {
  filingCostDetailsByPID: [],
};

export const filingCostReducer: Reducer<IFilingCostState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FILING_COST_DETAILS_BY_PID:
      return {
        ...state,
        filingCostDetailsByPID: action.payload,
      };
    default:
      return state;
  }
};
export default filingCostReducer;
